<template>
	<div class="steps__step-form">
		<h3 class="h4 h4--b">
			Who from The Boundary Live is involved in this project?
		</h3>
		<p class="mb-24">
			All fields are required unless indicated as optional.
		</p>
		<form
			class="form form--fixed-fields"
			@submit.prevent="updateForm"
		>
			<InputComponent
				:value="form_fields.business_development"
				type="checkboxes-dropdown"
				input-id="business-development"
				name="business-development"
				label="Business Development Lead"
				placeholder="Search"
				:options="filtered_business_developers"
				:selection-label="selected_business_developers_label"
				filter-key="business_development"
				:filter-search="form_fields.business_development.search_query"
				:active-values="form_fields.business_development.values"
				:required="true"
				:errors="form_errors.business_development || null"
				@update:value="( value ) => handleCheckboxDropdownUpdate( value, 'business_development' )"
			/>
			<InputComponent
				:value="form_fields.project_manager"
				type="checkboxes-dropdown"
				input-id="project-manager"
				name="project-manager"
				label="Project Manager"
				sub-label="Optional"
				placeholder="Search"
				:options="filtered_project_managers"
				:selection-label="selected_project_managers_label"
				filter-key="project_manager"
				:filter-search="form_fields.project_manager.search_query"
				:active-values="form_fields.project_manager.values"
				:required="false"
				:errors="form_errors.project_manager || null"
				@update:value="( value ) => handleCheckboxDropdownUpdate( value, 'project_manager' )"
			/>
			<button
				class="button button--fill"
				type="submit"
			>
				Save {{ stepTitle }}
			</button>
		</form>
	</div>
</template>

<script setup>
import { useNewProjectStore } from '../../stores/new-project.js';
import { ref, computed, defineProps, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import InputComponent from '../InputComponent';

const new_project_store = useNewProjectStore();
const {
	getUserProfile,
	getBoundaryStaffUsers,
	validateNewProjectStep,
	setCheckboxDropdownValue,
	removeCheckboxDropdownValue
} = new_project_store;
const {
	form_fields,
	form_errors,
	filtered_business_developers,
	selected_business_development_leads,
	filtered_project_managers,
	selected_project_managers,
	user_profile
} = storeToRefs( new_project_store );

defineProps( {
	stepTitle: {
		required: true,
		type: String,
		default: ''
	}
} );

const loading = ref( true );

onMounted ( async() => {
	await getUserProfile();
	await getBoundaryStaffUsers();

	if (
		( !form_fields.value.business_development.values || !form_fields.value.business_development.values.length )
		&& user_profile != null
		&& user_profile.value.id != null
	) {
		setCheckboxDropdownValue( user_profile.value.id, 'business_development' );
	}

	loading.value = false;
} );

async function updateForm() {
	validateNewProjectStep();
}

const handleCheckboxDropdownUpdate = ( object, handle ) => { // eslint-disable-line snakecasejs/snakecasejs
	if ( object.checked ) {
		setCheckboxDropdownValue( object.value, handle );
	} else {
		removeCheckboxDropdownValue( object.value, handle );
	}
};

const selected_business_developers_label = computed( () => {
	return selected_business_development_leads.value
		.map( item => item.label )
		.join( ', ' )
	;
} );
const selected_project_managers_label = computed( () => {
	return selected_project_managers.value
		.map( item => item.label )
		.join( ', ' )
	;
} );

</script>
